;
(function ($) {
  var dataKey = 'app.scrollTop';
  var ScrollTop = function ScrollTop(element, options) {
    this.element = element;
    this.init(options);
  };
  ScrollTop.prototype = {
    value: {
      offset: 1000,
      delay: 300,
      speed: 500
    },
    classes: {
      visible: 'scrolltop--visible'
    },
    /**
     * Initialise Scroll Top
     * Listens for a mouse click on the button.
     * Listens for a key press (spacebar) on the button. This is for accessibility purposes.
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      if ($(window).scrollTop() >= this.value.offset) {
        this._showScrollToTop(this.element);
      }
      this._onWindowScroll();
      $(this.element).on('click', function (e) {
        _this._scrollToTop(e);
      });
      $(this.element).bind('keypress', function (e) {
        if (e.keyCode === 32) {
          _this._scrollToTop(e);
          return false;
        }
      });
    },
    /**
     * On Window Scroll
     * Listens for the user scrolling the window.
     * If the window is scrolled beyond the offset the required modifier classes are applied to the element.
     * @private
     */

    _onWindowScroll: function _onWindowScroll() {
      var _this = this;
      var $elm = $(this.element);
      $(window).scroll(function () {
        if ($(window).scrollTop() >= _this.value.offset) {
          _this._showScrollToTop($elm);
        } else {
          _this._hideScrollToTop($elm);
        }
      });
    },
    /**
     * Show Scroll Button
     * Adds the required modifer class to the button to make it visible.
     * @private
     */

    _showScrollToTop: function _showScrollToTop($elm) {
      $elm.show();
      $elm.addClass(this.classes.visible);
    },
    /**
     * Hide Scroll Button
     * Removes the required modifer class to the button to make it non-visible.
     * @private
     */

    _hideScrollToTop: function _hideScrollToTop($elm) {
      if ($elm.hasClass(this.classes.visible)) {
        $elm.removeClass(this.classes.visible);
        setTimeout(function () {
          $elm.hide();
        }, this.value.delay);
      }
    },
    /**
     * Scroll To Top
     * Scrolls the current page to the top of the window.
     * @private
     */

    _scrollToTop: function _scrollToTop(e) {
      var _this = this;
      $('html, body').animate({
        scrollTop: $('body').offset().top
      }, _this.value.speed);
      e.preventDefault();
    }
  };

  /**
   * Global callback function which by default all [data-scrolltop] triggers this plugin.
   * @method $.fn.app_scrollTop()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_scrollTop();
   */

  $.fn.app_scrollTop = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof ScrollTop) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new ScrollTop(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);